export default "__VITE_ASSET__ziE03ui0__"